/**
 * A field value as a reviewer should read it.
 *
 * `String(value)` was enough while every answer was a scalar. A repeating field
 * group — the creditors on a pleasure boat mortgage — writes an array of rows
 * into one field, and `String()` on that is `[object Object]` in the case file
 * a maker is meant to check before approving it.
 *
 * The engine has the same function for the citizen's review summary. Two copies
 * rather than a shared package because the console renders a stored value it
 * receives over HTTP and knows nothing about the spec; keeping it here means
 * the console can be read without the engine.
 */
export function formatFieldValue(value: unknown): string {
  if (value === null || value === undefined || value === '') return '—';
  if (Array.isArray(value)) {
    return value.map((entry, index) => `${index + 1}. ${formatFieldValue(entry)}`).join('\n');
  }
  if (typeof value === 'object') {
    return Object.entries(value as Record<string, unknown>)
      .filter(([, entry]) => entry !== null && entry !== undefined && entry !== '')
      .map(([key, entry]) => `${key}: ${formatFieldValue(entry)}`)
      .join(', ');
  }
  return String(value);
}
